module.exports = __webpack_public_path__ + "static/media/value_prop_img_3.eace6872.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value_prop_img_3.jpg
// module id = 2666
// module chunks = 0